import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formDefinitionKeys } from '@/lib/queryKeys';
import type { FormDefinition } from '@/types/appointmentForm';

export type FormDefinitionStatus = 'ACTIVE' | 'ARCHIVED';
export type FormPurpose = 'VISIT' | 'BOOKING';

interface UseFormDefinitionsParams {
  status?: FormDefinitionStatus;
  /** Filter to a surface: 'VISIT' forms vs 'BOOKING' surveys. */
  purpose?: FormPurpose;
}

export function useFormDefinitions(params: UseFormDefinitionsParams = {}) {
  const { status = 'ACTIVE', purpose } = params;
  return useApiQuery<FormDefinition[]>({
    queryKey: formDefinitionKeys.list({ status, purpose }),
    queryFn: () =>
      apiGet<FormDefinition[]>(operationsClient, appointmentFormEndpoints.definitions(), {
        params: { status, ...(purpose ? { purpose } : {}) },
      }),
    showErrorToast: false,
  });
}

export function useAppointmentFormDefinitions(appointmentId: string | undefined) {
  return useApiQuery<FormDefinition[]>({
    queryKey: formDefinitionKeys.byAppointment(appointmentId ?? ''),
    queryFn: () =>
      apiGet<FormDefinition[]>(
        operationsClient,
        appointmentFormEndpoints.definitionsForAppointment(appointmentId as string),
      ),
    enabled: Boolean(appointmentId),
    showErrorToast: false,
  });
}
